import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AdminInquiries from "./pages/AdminInquiries";
import Showcase from "./pages/Showcase";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1F1A17",
            color: "#FAF6F4",
            border: "1px solid #594838",
            fontFamily: "Nunito, sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
